///////////////////////////////////////////////////////////////////////
// GuideState.detailPlaning
///////////////////////////////////////////////////////////////////////

import { itx } from "../../translationItx/itx";
import guideSequence_addSceneMultiplexer from "../sequences/guideSequence_addSceneMultiplexer";
import sequence_connectConnectableObjWithEachOther from "../sequences/sequence_connectConnectableObjWithEachOther";
import { ToDoItem } from "../ToDoItem";

import StoryLine_BaseIntroduction from "./BaseIntroduction";
import storyLines_Framework from "./Framework";
import StoryLine_Prefixes from "./Prefixes";
import StoryLine from "./StoryLine";

class StoryLine_ScenesAndMultiplexer extends StoryLine {
  className = "ScenesAndMultiplexer"; // no itx

  firstItem = (): ToDoItem => {
    return this.createScene();
  };

  description = () => {
    return itx("guideState.detailPlaning");
  };

  ////////////////////////////////////////////////////////////////////
  createScene = (): ToDoItem => {
    return new ToDoItem({
      id: "createScene",
      text: itx("ToDoItemLine.createScene"),
      subSteps: undefined,
      nextStep: this.connectionConsumerWithScene,
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Scene") {
            res = true;
          }
        });
        return res;
      },
      typeForPattern: "Scene", // no itx
      pattern: guideSequence_addSceneMultiplexer,
      prio: 7,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionConsumerWithScene = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionConsumerWithScene",
      text: itx("ToDoItemLine.connectionConsumerWithScene"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.connectionButtonWithScene,
      hasToBeDoneBevoreStep: [this.createScene, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allScenes().forEach((consumer) => {
          consumer.connections.forEach((con) => {
            if (con.fromDevice?.className.includes("Consumer") || con.toDevice?.className.includes("Consumer")) {
              res = true;
            }
          });
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Scene", "Consumer"); // no itx
      },
      prio: 8,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionScenewithConsumer = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionScenewithConsumer",
      text: itx("ToDoItemLine.connectionScenewithConsumer"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.connectionButtonWithScene,
      hasToBeDoneBevoreStep: [this.createScene, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Scene") {
            scene.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Consumer") || con.toDevice?.className.includes("Consumer")) {
                res = true;
              }
            });
          }
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Consumer", "Scene"); // no itx
      },
      prio: 9,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionButtonWithScene = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionButtonWithScene",
      text: itx("ToDoItemLine.connectionButtonWithScene"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.createMultiplexer,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createButton, this.createScene],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allButtons().forEach((button) => {
          button.buttonChannels.forEach((bc) => {
            bc.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Scene") || con.toDevice?.className.includes("Scene")) {
                res = true;
              }
            });
          });
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Scene", "Button"); // no itx
      },
      prio: 10,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionSceneWithButton = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionSceneWithButton",
      text: itx("ToDoItemLine.connectionSceneWithButton"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.createMultiplexer,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createButton, this.createScene],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Scene") {
            scene.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Button") || con.toDevice?.className.includes("Button")) {
                res = true;
              }
            });
          }
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Button", "Scene"); // no itx
      },
      prio: 11,
    });
  };
  ////////////////////////////////////////////////////////////////////////

  createMultiplexer = (): ToDoItem => {
    return new ToDoItem({
      id: "createMultiplexer",
      text: itx("ToDoItemLine.createMultiplexer"),
      subSteps: undefined,
      nextStep: this.connectionConsumerWithMultiplexer,
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Multiplexer") {
            res = true;
          }
        });
        return res;
      },
      typeForPattern: "Multiplexer",
      pattern: guideSequence_addSceneMultiplexer,
      prio: 12,
    });
  };

  ////////////////////////////////////////////////////////////////////////
  connectionConsumerWithMultiplexer = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionConsumerWithMultiplexer",
      text: itx("ToDoItemLine.connectionConsumerWithMultiplexer"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.connectionButtonWithMultiplexer,
      hasToBeDoneBevoreStep: [this.createMultiplexer, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allConsumers().forEach((consumer) => {
          consumer.connections.forEach((con) => {
            if (con.fromDevice?.className.includes("Multiplexer") || con.toDevice?.className.includes("Multiplexer")) {
              res = true;
            }
          });
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Multiplexer", "Consumer"); // no itx
      },
      prio: 13,
    });
  };

  ////////////////////////////////////////////////////////////////////////
  connectionMultiplexerWithConsumer = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionMultiplexerWithConsumer",
      text: itx("ToDoItemLine.connectionMultiplexerWithConsumer"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.connectionButtonWithMultiplexer,
      hasToBeDoneBevoreStep: [this.createMultiplexer, StoryLine_BaseIntroduction.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Multiplexer") {
            scene.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Consumer") || con.toDevice?.className.includes("Consumer")) {
                res = true;
              }
            });
          }
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Button", "Multiplexer"); // no itx
      },
      prio: 14,
    });
  };
  ////////////////////////////////////////////////////////////////////////

  connectionButtonWithMultiplexer = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionButtonWithMultiplexer",
      text: itx("ToDoItemLine.connectionButtonWithMultiplexer"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: storyLines_Framework.select_A,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createButton, this.createMultiplexer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allButtons().forEach((button) => {
          button.buttonChannels.forEach((bc) => {
            bc.connections.forEach((con) => {
              if (
                con.fromDevice?.className.includes("Multiplexer") ||
                con.toDevice?.className.includes("Multiplexer")
              ) {
                res = true;
              }
            });
          });
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Multiplexer", "Button"); // no itx
      },
      prio: 15,
    });
  };

  ////////////////////////////////////////////////////////////////////////
  connectionMultiplexerWithButton = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionMultiplexerWithButton",
      text: itx("ToDoItemLine.connectionMultiplexerWithButton"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: storyLines_Framework.select_A,
      hasToBeDoneBevoreStep: [StoryLine_BaseIntroduction.createButton, this.createMultiplexer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.sceneGroup.forEach((scene) => {
          if (scene.className == "Multiplexer") {
            scene.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Button") || con.toDevice?.className.includes("Button")) {
                res = true;
              }
            });
          }
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Button", "Multiplexer"); // no itx
      },
      prio: 16,
    });
  };

  ////////////////////////////////////////////////////////////////////////
}

const storyLine_ScenesAndMultiplexer = new StoryLine_ScenesAndMultiplexer();
export default storyLine_ScenesAndMultiplexer;
